import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import { ProjectListTableHeader } from '@modules/BillOfMaterials/Components/BillOfMaterials/ProjectsList/ProjectListTable/ProjectListTableHeader/ProjectListTableHeader';
import React from 'react';
import { useProjectStore } from '../../../../../../Stores/ProjectStore';
import { BasicLoader } from '@shared/Ui/Loaders/BasicLoader/BasicLoader';
import css from './ProjectListTable.module.css';
import { RenderProjectTableRow } from '@modules/BillOfMaterials/Components/BillOfMaterials/ProjectsList/ProjectListTable/RenderProjectTableRow/RenderProjectTableRow';
import { useProjectsListViewModel } from '@viewModels/ProjectsListViewModel/ProjectsListViewModel';

export const ProjectListTable: React.FC = () => {
    const [isDesktop] = useMediaType();
    const { customProjects } = useProjectsListViewModel();

    return (
        <div className={css.table}>
            {isDesktop && <ProjectListTableHeader />}
            {customProjects ? (
                <RenderProjectTableRow customProjects={customProjects.data} />
            ) : (
                <div className={css.emptyProjects}>Failed to load projects</div>
            )}
        </div>
    );
};
